import React, { useState } from "react";
// import { useGetPastSignedEncounterPreviewQuery } from "app/redux/providerNoteService";
import { shallowEqual, useSelector } from "react-redux";
import SignedEncounterContent from "./SignedEncounterContent";
import MainPageDialog from "../../components/dialog";
import { useGetPastSignedEncounterPreviewQuery } from "../../services/providerNoteService";
import { DatePickerFeild } from "../../components/reactHookFormFields/datePicker";
import { ReactSelectField } from "../../components/reactHookFormFields/selectField";
import { useForm } from "react-hook-form";
import {
  useGetTriageMetaQuery,
  useTasksMetaQuery,
} from "../../services/triageServices";
import { formattedDate } from "../../helper";

const SignedEncounterDialogue = ({
  setShowSignedEncountersDialogue,
  shareDataDetail,
  selectedChat,
}) => {
  // const { selectedNote } = useSelector(
  //   ({ providerNote }) => ({
  //     selectedNote: providerNote.selectedNote,
  //   }),
  //   shallowEqual
  // );
  const [filterValues, setFilterValues] = useState({
    date: "",
    provider_id: "",
    visit_reason: "",
    encounter_types: "",
  });
  const { control, handleSubmit, getValues, setValue } = useForm();
  const {
    practice: { id: practice_id },
    auth: authToken,
    ...data
  } = JSON.parse(localStorage.getItem("auth"));
  const { data: taskAndAlertsSettings } = useTasksMetaQuery();
  const { data: getAppointmentsList } = useGetTriageMetaQuery();

  const { data: pastSignedEncountersList, isFetching: isSignedLoading } =
    useGetPastSignedEncounterPreviewQuery({
      ...filterValues,
      filter_encounters: 1,
      pid: selectedChat?.pid,
      // exclude_encounter_id: selectedChat?.encounter?.id,
      page: 1,
      limit: 100,
      encounter_type: "provider_note",
      status: "signed",
    });

  const cancelSignedHandler = () => {
    if (shareDataDetail) {
      shareDataDetail?.closeDialog();
    } else {
      setShowSignedEncountersDialogue(false);
    }
  };

  const footerSignedList = [
    shareDataDetail && {
      title: "Attach",
      type: "save",
      action: () =>
        shareDataDetail?.attachHandler(shareDataDetail?.selectedFiles),
    },
    {
      title: "Cancel",
      type: "cancel",
      action: cancelSignedHandler,
    },
  ];
  const submitData = (data) => {
    console.log(data, "Sasas");
    setFilterValues({
      date:
        formattedDate(data?.start_date, "YYYY-MM-DD") +
        "," +
        formattedDate(data?.end_date, "YYYY-MM-DD"),
      provider_id:
        data?.provider_id?.length > 0
          ? data?.provider_id?.map((v, k) => v?.id)?.join(",")
          : "",
      visit_reason: data?.visit_reason?.slug,
      encounter_types: data?.encounter_types?.slug,
    });
  };
  const resetHandler = () => {
    Object.entries(getValues()).forEach(([name, value]) => setValue(name, ""));
  };
  return (
    <div>
      <MainPageDialog
        title={
          shareDataDetail ? "Attach Encounters" : "Import Past Encounter Data"
        }
        footer={true}
        footerList={footerSignedList}
        onCancelHandler={cancelSignedHandler}
      >
        <div className="grid grid-cols-8 gap-3.5 py-3">
          <div className="col-span-2 w-full">
            <DatePickerFeild
              control={control}
              title="Start Date"
              name="start_date"
              dateTime={false}
            />
          </div>
          <div className="col-span-2 w-full">
            <DatePickerFeild
              control={control}
              title="End Date"
              name="end_date"
              dateTime={false}
            />
          </div>
          <div className="col-span-2 w-full">
            <ReactSelectField
              title="Provider"
              name="provider_id"
              isMulti={true}
              control={control}
              optionData={taskAndAlertsSettings?.provider_list?.map((v) => {
                return { ...v, label: v?.name };
              })}
            />
          </div>
          <div className="col-span-2 w-full">
            <ReactSelectField
              title="Visit Reason"
              name="visit_reason"
              control={control}
              optionData={getAppointmentsList?.data?.visit_reasons?.map((v) => {
                return { ...v, label: v?.title };
              })}
            />
          </div>
          <div className="col-span-2 w-full">
            <ReactSelectField
              title="Encounter Type"
              name="encounter_types"
              control={control}
              optionData={getAppointmentsList?.data?.visit_types?.map((v) => {
                return { ...v, label: v?.type };
              })}
            />
          </div>
          <div className="col-span-2 flex gap-2 items-center ">
            <button
              className="bg-bgGreen hover:bg-primary-hover text-white p-2 cursor-pointer"
              onClick={handleSubmit(submitData)}
            >
              Search
            </button>
            <button
              onClick={() => resetHandler()}
              type="button"
              className="bg-gray-200 hover:bg-gray-300 p-2 cursor-pointer"
            >
              Reset
            </button>
          </div>
        </div>
        <SignedEncounterContent
          selectedNote={selectedChat}
          pastSignedEncountersList={pastSignedEncountersList}
          cancelSignedHandler={cancelSignedHandler}
          isSignedLoading={isSignedLoading}
          shareDataDetail={shareDataDetail}
        />
      </MainPageDialog>
    </div>
  );
};

export default SignedEncounterDialogue;
